var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.56,75.28V30.71l26.42,0.3h0.05h0.05l0,0c0.05,0,4.31,0.05,7.37,3.06c2.16,2.16,3.26,5.36,3.26,9.57 c0,10.58-10.58,11.03-11.73,11.03H42.94l0.15-9.47h9.97c1.55,0,2.81-1.25,2.81-2.81s-1.25-2.81-2.81-2.81H37.53l-0.35,20.75h16.79 c0.15,0,4.31-0.05,8.47-2.06c4.06-1.95,8.87-6.07,8.87-14.64c0-5.76-1.65-10.33-4.91-13.58c-4.56-4.56-10.73-4.71-11.33-4.71 L22.99,25v50.33c0,1.55,1.25,2.81,2.81,2.81S28.61,76.83,28.56,75.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,6.25C22.89,6.25,5,23.6,5,45s17.89,38.75,40,38.75S85,66.4,85,45S67.11,6.25,45,6.25z M45,78.13 C26.05,78.13,10.61,63.3,10.61,45S26.05,11.87,45,11.87S79.39,26.7,79.39,45S63.95,78.13,45,78.13z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGp);
export default __webpack_public_path__ + "static/media/gp.0509d4f744b5fb5f6b1dec9eb93e709b.svg";
export { ForwardRef as ReactComponent };